import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { colorCSS } from '../../../styles';
import { useHeaderFooterContext } from '../../../components';
import throttle from 'lodash.throttle';
const ProgressBar = styled.div `
  width: 100%;
  position: absolute;
  left: 0%;
  top: 90%;
  bottom: 0%;
  background: transparent;
`;
const Progress = styled.div `
  ${({ yPercent }) => yPercent >= 100
    ? `background: ${colorCSS('G200')};`
    : `background: linear-gradient(90deg, ${colorCSS('P400')} 0%, ${colorCSS('M200')} 99%);`};
  ${({ yPercent }) => `width: ${yPercent}%;`};
  height: 100%;
  transition: all 85ms ease-in-out;
`;
export function HeaderProgressBar() {
    const [yPercent, setYPercent] = useState(0);
    const { footerHeight } = useHeaderFooterContext();
    useEffect(() => {
        // define handler
        const scrollPercentHandler = throttle(() => {
            const scrollTop = window.scrollY;
            const docHeight = document.body.offsetHeight;
            const windowHeight = window.innerHeight;
            const scrollPercent = windowHeight + footerHeight >= docHeight
                ? 100
                : (scrollTop / (docHeight - windowHeight - footerHeight)) * 100;
            setYPercent(scrollPercent);
        }, 100);
        // set listener
        window.addEventListener('scroll', scrollPercentHandler);
        // remove listener
        return () => {
            window.removeEventListener('scroll', scrollPercentHandler);
        };
    }, [footerHeight]);
    return (React.createElement(ProgressBar, null,
        React.createElement(Progress, { yPercent: yPercent })));
}
//# sourceMappingURL=HeaderProgressBar.js.map